import { jsx } from "react/jsx-runtime";
import { EditorAtom, useEditor, useQuickReactor } from "@tldraw/editor";
import { useEffect, useRef, useState } from "react";
import { useActions } from "../../context/actions.mjs";
import { TldrawUiMenuActionItem } from "../primitives/menus/TldrawUiMenuActionItem.mjs";
const backToContentSuppressed = new EditorAtom("backToContentSuppressed", () => false);
const suppressTimeout = new EditorAtom("backToContentSuppressTimeout", () => null);
const BACK_TO_CONTENT_APPEAR_DELAY_MS = 1e3;
function suppressBackToContent(editor, durationMs) {
  backToContentSuppressed.set(editor, true);
  const pending = suppressTimeout.get(editor);
  if (pending !== null) clearTimeout(pending);
  const id = editor.timers.setTimeout(() => {
    backToContentSuppressed.set(editor, false);
    suppressTimeout.set(editor, null);
  }, durationMs);
  suppressTimeout.set(editor, id);
}
function BackToContent() {
  const editor = useEditor();
  const actions = useActions();
  const [showBackToContent, setShowBackToContent] = useState(false);
  const rIsShowing = useRef(false);
  const rAppearTimeout = useRef(null);
  useQuickReactor(
    "toggle showback to content",
    () => {
      let showBackToContentNow = false;
      if (!backToContentSuppressed.get(editor)) {
        const shapeIds = editor.getCurrentPageShapeIds();
        if (shapeIds.size) {
          showBackToContentNow = shapeIds.size === editor.getNotVisibleShapes().size;
        }
      }
      if (showBackToContentNow === rIsShowing.current) {
        if (rAppearTimeout.current !== null) {
          clearTimeout(rAppearTimeout.current);
          rAppearTimeout.current = null;
        }
        return;
      }
      if (showBackToContentNow) {
        if (rAppearTimeout.current === null) {
          rAppearTimeout.current = editor.timers.setTimeout(() => {
            rAppearTimeout.current = null;
            rIsShowing.current = true;
            setShowBackToContent(true);
          }, BACK_TO_CONTENT_APPEAR_DELAY_MS);
        }
      } else {
        if (rAppearTimeout.current !== null) {
          clearTimeout(rAppearTimeout.current);
          rAppearTimeout.current = null;
        }
        rIsShowing.current = false;
        setShowBackToContent(false);
      }
    },
    [editor]
  );
  useEffect(() => {
    return () => {
      if (rAppearTimeout.current !== null) {
        clearTimeout(rAppearTimeout.current);
        rAppearTimeout.current = null;
      }
    };
  }, []);
  if (!showBackToContent) return null;
  return /* @__PURE__ */ jsx(
    TldrawUiMenuActionItem,
    {
      actionId: "back-to-content",
      onSelect: () => {
        actions["back-to-content"].onSelect("helper-buttons");
        setShowBackToContent(false);
      }
    }
  );
}
export {
  BACK_TO_CONTENT_APPEAR_DELAY_MS,
  BackToContent,
  suppressBackToContent
};
//# sourceMappingURL=BackToContent.mjs.map
